import { BaseApi } from '../../common/api/base-api.interface';
import { ShapeNodeCreateProps } from '../models/shape-node-create-props';
import { getApiForNodeType } from './../../common/api/api-map';
import { createShapeNode } from './create-shape-node';
import { setupShapeNode } from './setup-shape-node';

export const shapeNodeAPI = (): BaseApi<ShapeNodeCreateProps> => ({
  name: 'shapeNode',
  setup: setupShapeNode,
  create: createShapeNode,
  getCursor: () => 'crosshair',
  ...getApiForNodeType('shapeNode'),
});
